import idlImport from './niq_faucet.did.js';
export const idlFactory = idlImport;
export const canisterId = "h64ct-uaaaa-aaaah-qacka-cai";
